export default "__VITE_ASSET__BrrqTSa3__"